"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var domEvents_1 = require("../../mixins/domEvents");
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
exports.Button = domEvents_1.focuseable(function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'button' : _b, loading = _a.loading, disabled = _a.disabled, _c = _a.buttonType, buttonType = _c === void 0 ? 'button' : _c, onClick = _a.onClick, className = _a.className, rest = __rest(_a, ["as", "loading", "disabled", "buttonType", "onClick", "className"]);
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as }, (as === 'input' ? { type: buttonType } : undefined), { disabled: disabled || loading, className: [
            'button',
            loading && 'loading',
            disabled && 'disabled',
            className,
        ], onClick: !disabled ? onClick : undefined }, rest)));
});
//# sourceMappingURL=Button.js.map